import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'accent';
  fullWidth?: boolean;
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  fullWidth = false,
  children,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-lg font-bold rounded-full transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gold';
  const variants = {
    primary: 'bg-gradient-to-r from-gold to-gold-light text-brown hover:from-gold-light hover:to-gold border border-transparent',
    secondary: 'bg-brown text-cream hover:bg-brown-light border border-transparent',
    outline: 'bg-transparent border-2 border-gold text-gold hover:bg-gold/10',
    accent: 'bg-gradient-to-r from-accent to-accent-dark text-white hover:from-accent-dark hover:to-accent border border-transparent shadow-accent/30 hover:shadow-accent/50'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <motion.button whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${widthClass} ${className}`} {...props} data-id="element-346">
      {children}
    </motion.button>;
}